import AuthModal from '../components/auth-modal/auth-modal';

import internalLink from './internal-link';

const registerLink = (calc, { element, location }, text) => {
  const trkParams = {
    element,
    location,
    copy: 'get_your_free_credit_score',
  };
  const link = internalLink(
    calc,
    '/home/register?flow=credit-score',
    trkParams
  );
  return {
    linkComponent: AuthModal,
    url: link,
    text,
    href: link,
  };
};
export default registerLink;
